export * from './generateAreaVariations';
